/* Enhancements do not change products, cart contents, subscriptions or consent. */
(() => {
  function enhance(root = document) {
    root.querySelectorAll('.swiper').forEach((slider) => {
      const previous = slider.querySelector('.swiper-nav-button--prev');
      const next = slider.querySelector('.swiper-nav-button--next');
      if (previous) previous.setAttribute('aria-label', 'Vorige afbeelding');
      if (next) next.setAttribute('aria-label', 'Volgende afbeelding');
    });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
    }
  }
  const shortenReviewButtons = (root) => {
    root.querySelectorAll('#yotpo-main-widget-btn, .yotpo button, .yotpo [role="button"]').forEach(button => {
      if (button.textContent.trim() === 'Schrijf als eerste een beoordeling') {
        const label = [...button.querySelectorAll('*')].find(node => node.childElementCount === 0 && node.textContent.trim() === 'Schrijf als eerste een beoordeling');
        if (label) label.textContent = 'Schrijf een beoordeling';
        else if (!button.childElementCount) button.textContent = 'Schrijf een beoordeling';
      }
    });
  };
  const observeReviews = () => {
    document.querySelectorAll('.product-info-inner > .yotpo.bottomLine').forEach(widget => {
      const showActualReviews = () => {
        const zero = [...widget.querySelectorAll('a,span')].some(label => /^0\s+(?:beoordelingen?|reviews?)$/i.test(label.textContent.trim()));
        widget.classList.toggle('mb-no-reviews', zero);
      };
      showActualReviews();
      new MutationObserver(showActualReviews).observe(widget, {childList:true, subtree:true, characterData:true});
    });
    document.querySelectorAll('.pdp-accordion').forEach(widget => {
      shortenReviewButtons(widget.parentElement || document);
      new MutationObserver(() => shortenReviewButtons(widget.parentElement || document)).observe(widget, { childList:true, subtree:true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeReviews);
  else observeReviews();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
